
    import {Component, Vue, Watch} from 'vue-property-decorator';
    import {fileApi, authorizeCertApi, measuringStandardApi, mechanismApi, dictApi} from "@/api/organization";
    import {rulesApi} from "@/api/rules";
    import baseUrl, {uploadPage, imageUrl} from "../../constants";
    const {CodeToText, regionData} = require("@/js/region/region");
    import ckeditor4 from "@/components/CkeditorComponent.vue";
    import SelectMechanism from "@/components/SelectMechanism.vue";
    import MeasuringRange from "@/components/MeasuringRange.vue";
    import tempSave from "@/components/TempSave.vue";
    import TableShowRangeBody from "@/components/table-show-range-body.vue";
    import TableShowRangeHead from "@/components/table-show-range-head.vue";
    import {Param} from "@/js/ParamList";
    import TableShowRangeBodyEjian from "@/components/table-show-range-body-ejian.vue";

    @Component({
        name: "authorizeCertDetail",
        components: {
          TableShowRangeBodyEjian,
            TableShowRangeHead,
            TableShowRangeBody,
            SelectMechanism,
            ckeditor4,
            MeasuringRange,
            tempSave
        }
    })
    export default class Home extends Vue {
        title = "计量授权证书详情页";
        pageType = "-1";  //0添加  1编辑  2查看 4审核
        id = "0";   //计量授权证书id
        manageStatus = 3; //3：初始添加， 5 换证添加
        form = {
            /** 机构名称 */
            name: '',
            /** 地址 */
            address: '',
            /** 法人代表*/
            legalPerson: '',
            /** 主管部门名称 */
            competentDepartName: '',
            /** 主管部门Id  */
            competentDepartId: '',
            /** 主管部门别名ID */
            competentDepartNameId: '',
            /** 授权区域 */
            authorizedArea: '',
            authorizedAreaText: '',
            authorizedAreaArr: '',
            /** 证书编号 */
            certificateNo: '',
            /** 发证日期*/
            issuedDate: '',
            /** 有效日期*/
            termValidity: '',
            /** 发证机关 */
            issuingAuthority: '',
            /** 发证机关NameId */
            issuingAuthorityNameId: '',
            /** 批准人 */
            approverName: '',
            /** 影印件*/
            enclosure: '',
            /** pdf 文件路径 */
            pdfPath: '',
            /**
             * 0:待提交
             * 1:未审核
             * 2:已生效
             * 3:未通过
             * */
            status: 0,
            //管理状态 3初始 5 换证添加
            manageStatus: {value: 3},
        }
        form2 = {
            isNone: false,
            //已选检验项目
            verificationItems: [],
            //所有检验项目
            measuringItems: [],
            //未选择的检验项目
            measuringItemsFilter: [],
        }

        form3 = {
            isNone: false,
            //已选检测项目
            testItems: [],
            //所有检测项目
            measuringItems: [],
            //未选择的检测项目
            measuringItemsFilter: [],
        }

        form4 = {
            //商品量授权校准
            isNone: false,
            goodsItems: [],
        }

        formRules = {
            name: [{required: true, message: '请输入机构名称', trigger: 'blur'}],
            address: [{required: true, message: '请输入地址', trigger: 'blur'}],
            legalPerson: [{required: true, message: '请输入法人代表', trigger: ['blur', 'change']}],
            competentDepartId: [{required: true, message: '请选择主管部门', trigger: 'change'}],
            authorizedArea: [{required: true, message: '请选择授权区域', trigger: 'blur'}],
            certificateNo: [{required: true, message: '请输入证书编号', trigger: 'blur'}],
            issuedDate: [{required: true, message: '请选择发证日期', trigger: 'blur'}],
            termValidity: [{required: true, message: '请选择有效期至', trigger: 'blur'}],
            issuingAuthority: [{required: true, message: '请选择发证机关', trigger: 'change'}],
            approverName: [{required: true, message: '请输入批准人', trigger: 'blur'}],
            enclosure: [{required: true, message: '请上传授权证书影印件', trigger: 'change'}],
        }
        form2Rules = {
            measuringItemId: [{required: true, message: '请选择检定项目', trigger: 'blur'}],
            standardNumber: [{required: true, message: '请输入规范编号', trigger: 'blur'}],
            standardName: [{required: true, message: '请输入规范名称', trigger: 'blur'}],
            lowerLimit: [{required: true, message: '请输入下限', trigger: 'blur'}],
            upperLimit: [{required: true, message: '请输入上限', trigger: 'blur'}],
            upperUnit: [{required: true, message: '请输入上限单位', trigger: 'blur'}],
            lowerUnit: [{required: true, message: '请输入下限单位', trigger: 'blur'}],
            scope: [{required: true, message: '请输入准确度等级/测量扩展不确定度', trigger: 'blur'}],
        }
        form3Rules = {
            measuringItemId: [{required: true, message: '请选择检测项目', trigger: 'blur'}],
            standardNumber: [{required: true, message: '请输入规范编号', trigger: 'blur'}],
            standardName: [{required: true, message: '请输入规范名称', trigger: 'blur'}],
            lowerLimit: [{required: true, message: '请输入下限', trigger: 'blur'}],
            upperLimit: [{required: true, message: '请输入上限', trigger: 'blur'}],
            upperUnit: [{required: true, message: '请输入上限单位', trigger: 'blur'}],
            lowerUnit: [{required: true, message: '请输入下限单位', trigger: 'blur'}],
            scope: [{required: true, message: '请输入准确度等级/测量扩展不确定度', trigger: 'blur'}],
        }
        form4Rules = {
            projectId: [{required: true, message: '请选择项别名称', trigger: 'change'}],
            paramList: [{required: true, message: '请填写测量范围 和 不确定度等级', type: 'array'}],
            surveyRanges: [{required: true, message: '请填写测量范围', type: 'array'}],
            maxError: [{required: true, message: '请输入最大允许误差', trigger: 'blur'}],
            ruleId: [{required: true, message: '请选择规程规范', trigger: 'blur'}],
        }
        loading = false; //加载
        regionData = regionData
        regionDataAll = JSON.parse(JSON.stringify(regionData))
        baseUrl = baseUrl
        headers = {Authorization: ""}
        fileList = [] as any;
        private closePage: any;
        dialogImageUrl = "";
        imagePreviewVisible = false;
        accept = ".png,.jpg,.pdf";
        limit = 10;
        listType = "picture-card"
        userData = null as any;
        sysAuthorizeCertUpdate = false;// 授权证书审核 权限
        mode = 0; //0本单位 1全部 2审核
        review = {
            failText: '',
            failDialog: false,
        }

        addSurveyRanges = {
            visible: false,
            surveyRanges: [],
            params: null as any,
        }

        keyword = "" //器具名称模糊搜索 关键字
        projectList = []//器具项目列表
        measuringRulesFilterd = [] //规程规范过滤
        showAllLevels = false

        created() {
            this.loading = true;
            this.listDictInstrument();
            if (this.pageType !== '0') {
                this.init();
            }
            this.haveRight();
        }

        haveRight() {
            const right = this.$store.state.userRights;
            right.forEach((e: any) => {
                if (e.name == "授权证书审核") {
                    this.sysAuthorizeCertUpdate = true;
                }
            })
        }

        getTitle(){
            let title = '';
            if(this.pageType == '0'){
                title += '添加';
            }else if(this.pageType == '1'){
                title = '编辑';
            }else if(this.pageType == '2'){
                title = '查看';
            }else{
                title = '审核';
            }
            title += '计量授权证书';
            return title;
        }

        isBlockDisabled(mode: string){
            if(mode === 'block-1'){
               return (this.form.status === 2 && !this.sysAuthorizeCertUpdate) || this.pageType === '1';
            }else if(mode === 'block-2'){
                return (this.form.status === 2 && !this.sysAuthorizeCertUpdate) || this.pageType === '1';
            }else if(mode === 'block-3'){
                return (this.form.status === 2 && !this.sysAuthorizeCertUpdate) || this.pageType === '1';
            }else if(mode === 'block-4'){
                return (this.form.status === 2 && !this.sysAuthorizeCertUpdate) || this.pageType === '1';
            }
        }

        hasBtn(mode: string) {
            const pageType = this.pageType;
            const manageStatus = this.manageStatus;
            const {status} = this.form;
            if(mode === 'past'){
                return pageType === "4";
            }else if(mode === 'add'){
                return pageType === '0' || (pageType === '1' && status !== 2)
            }else if(mode === 'tempSave'){
                return pageType === '0' && manageStatus  === 3;
            }else if(mode === 'submit'){
                return ['0', '1'].indexOf(pageType) > -1 && (this.mode === 0)
            }else if(mode === 'audit-save'){
                return (['4'].indexOf(pageType) > -1) || (this.mode === 1 && this.sysAuthorizeCertUpdate)
            }
        }

        regionCodeToText(values: any) {
            let address = "";
            try {
                if (values) {
                    for (const arr of values) {
                        if (arr) {
                            if (address != "") address += ",";
                            const codes = arr as any;
                            for (const code of codes) {
                                const text = CodeToText[code];
                                address += text;
                            }

                        }
                    }
                }
            } catch (e) {
                console.log(e);
            }
            return address;
        }

        cellClass({columnIndex}: any) {
            if (columnIndex === 0) {
                return {"background-color": "#f5f7fa"}
            }
        }
        delItemRule(ruleList: any, rIndex: number) {
            ruleList.splice(rIndex, 1);
        }

        addItemRule(ruleList: any) {
            ruleList.push({
                ruleId: '',
                ruleName: '',
                ruleNumber: '',
            });
        }

        filterRules(keyword: string) {
            if (keyword != "") {
                let keyword1 = ""; // 正则匹配出 [A-Z]+
                let key1s = /[A-Za-z]+/i.exec(keyword);
                if (key1s != null && key1s.length > 0) {
                    keyword1 = key1s[0].toUpperCase();
                }

                let keyword2 = ""; //正则匹配出 \d+
                let key2s = /[\d-]+/i.exec(keyword);
                if (key2s != null && key2s.length > 0) {
                    keyword2 = key2s[0];
                }

                let keyword3 = ""; //正则匹配出 常见汉字
                let key3s = /[\u4E00-\u9FFF]+/i.exec(keyword);
                if (key3s != null && key3s.length > 0) {
                    keyword3 = key3s[0];
                }

                rulesApi.list({keyword1: keyword1, keyword2: keyword2, keyword3: keyword3}).then((r) => {
                    if (r.data.result === 0) {
                        this.measuringRulesFilterd = r.data.data;
                    }
                });
            } else {
                this.measuringRulesFilterd = [];
            }
        }

        filterGoodsItems(keyword: string) {
            this.keyword = keyword;
        }

        changeMeasuringRule(row: any) {
            const project: any = this.measuringRulesFilterd.find((p: any) => p.id === row.ruleId);
            if (project != null) {
                row.ruleName = project.name;
                row.ruleNumber = project.number;
            }
        }

        //获取单位详细信息
        getMechanism(orgId: string) {
            if (!orgId) {
                return;
            }
            mechanismApi.listMechanismV2({organizationId: orgId}).then((r) => {
                if (r.data.result == 0 && r.data.data.length > 0) {
                    this.form.legalPerson = r.data.data[0].userName;
                }
            });
        }

        changeProject(row: any) {
            this.showAllLevels = false;
            const projectList = this.projectList;
            const project = this.getProjectData(row.projectId, projectList);
            if (project.name) {
                row.name = project.name;
            }
        }

        listDictInstrument() {
            dictApi.listDictInstrument().then(r => {
                if (r.data.result === 0) {
                    const rData = r.data.data;
                    this.porjectTree(rData);
                    this.projectList = rData;
                }
            })
        }

        porjectTree(projectList: any) {
            projectList.forEach((project: any) => {
                if (project.children.length > 0) {
                    this.porjectTree(project.children);
                } else {
                    project.children = null;
                }
            })

        }

        getProjectData(projectId: number, projectList: any) {
            let result = null as any;
            for (let i = 0; i < projectList.length; i++) {
                const project = projectList[i];
                if (project.children != null) {
                    const r = this.getProjectData(projectId, project.children);
                    if (r != null) {
                        result = r;
                    }
                } else {
                    if (project.instrumentNameId === projectId) {
                        result = project;
                    }
                }
            }
            return result;
        }

        closeFail() {
            setTimeout(() => {
                this.review.failText = "";
            }, 500)
            this.review.failDialog = false;
        }

        changeAddress(values: any) {
            this.regionData = JSON.parse(JSON.stringify(this.regionDataAll));
            const addressCodes = [] as any;
            values.forEach((list: any) => {
                const code = list[list.length - 1];
                addressCodes.push(code);
            });
            addressCodes.forEach((code: string) => {
                const regionData = this.getRegionData(code, this.regionData);
                this.changeChild(regionData);
            });
        }

        changeChild(regionData: any) {
            if (regionData != null && regionData.children != null) {
                regionData.children.forEach((child: any) => {
                    child.disabled = true;
                    if (child.children) {
                        this.changeChild(child);
                    }
                });
            }
        }

        getRegionData(code: string, projectList: any) {
            let result = null as any;
            for (let i = 0; i < projectList.length; i++) {
                const project = projectList[i];
                if (project.value === code) {
                    result = project;
                    break;
                } else {
                    if (project.children != null) {
                        const r = this.getRegionData(code, project.children);
                        if (r != null) {
                            result = r;
                            break;
                        }
                    }
                }
            }
            return result;
        }

        passOrNot(status: number) {
            //通过或不通过
            if (status == 3) {
                //不通过，必须有原因
                if (this.review.failText == "") {
                    this.$message.error("请填写不通过原因");
                    return
                }
            }
            this.saveOrUpdate(status, () => {
                authorizeCertApi.updateStatus({
                    ids: this.id,
                    status: status,
                    reason: this.review.failText,
                    type: 0
                }).then(r => {
                    if (r.data.result === 0) {
                        this.$message.success("审核成功，1秒后返回上一页！");
                        this.closeFail();
                        setTimeout(() => {
                            this.closePage()
                        }, 1000);
                    }
                })
            });
        }

        clearData(row: any) {
            const r = [];
            let items = null as any;
            if (row.type === 0) {
                items = this.form2.verificationItems;
            } else if (row.type === 1) {
                items = this.form3.testItems;
            }
            for (let i = 0; i < items.length; i++) {
                const item = items[i];
                if (item.firstChild) {
                    r.push(item);
                } else if (item.number !== row.number) {
                    r.push(item);
                }
            }
            return r as any;
        }

        getItem(rowIndex: number, type: number) {
            if (type === 0) {
                return this.form2.verificationItems[rowIndex];
            } else if (type === 1) {
                return this.form3.testItems[rowIndex];
            }
        }
        clearItem(row: any){
            row.measuringItemId = '';
            row.name = "";
            row.paramList = [];
            row.measuringItemRulesList = [];
        }
        //项目更换
        changeItem(row: any){
          console.log(row);
          let measuringItems = [] as any;
            if (row.type === 0) {
                measuringItems = this.form2.measuringItems;
                this.getItemFilter('verification');
            } else if (row.type === 1) {
                measuringItems = this.form3.measuringItems;
                this.getItemFilter('test');
            }
            const item = measuringItems.find((item: any) => item.id == row.measuringItemId);
            if(item != null){
                row.name = item.name;
                // let paramList = [];
                // try{
                //     paramList = JSON.parse(item.surveyRangesJson)
                // }catch (e) {
                //     console.log(e);
                // }
                // row.paramList = paramList;
                row.accuracyLevelHtml = item.accuracyLevelHtml;
                row.surveyRangesHtml = item.surveyRangesHtml;
                row.measuringItemRulesList = item.measuringItemRulesList;
            }
        }
        changeDepart(e: any) {
            this.form.competentDepartNameId = e.mechanismNameId;
            this.form.competentDepartId = e.mechanismId;
            this.form.competentDepartName = e.mechanismName;
        }

        changeManufactory2(e: any) {
            this.form.issuingAuthorityNameId = e.mechanismNameId;
            this.form.issuingAuthority = e.mechanismName;
        }

        init() {
            this.headers.Authorization = this.$store.state.Authorization;
            this.id = this.$route.params.id;
            this.mode = Number(this.$route.params.mode);
            this.pageType = this.$route.params.pageType;
            this.manageStatus = Number(this.$route.params.manageStatus);
            const userData = this.$store.state.AuthedUser;
            this.userData = userData;
            if ((this.pageType !== '0') || (this.pageType === '0' && this.id !== '' &&this.id !== '0')) {
                this.loading = true;
                this.getDetail();
            }else {
                const verificationItems: any = [];
                const testItems: any = [];
                const goodsItems: any = [];
                verificationItems.push(this.itemAppend(1, 0, true, ""));
                testItems.push(this.itemAppend(1, 1, true, ""));
                goodsItems.push(this.itemV2Append(true, 1));
                this.form2.verificationItems = verificationItems;
                this.form3.testItems = testItems;
                this.form4.goodsItems = goodsItems;
                this.form.name = userData.organizationName == null ? '' : userData.organizationName;
                this.getMechanism(userData.organizationId);
                this.listMeasuringStandardItems(userData.organizationId);
                if (userData.organizationRegion != null && userData.organizationRegion) {
                    let address = "";
                    const regions = userData.organizationRegion.split(",");
                    regions.forEach((region: any) => {
                        address += CodeToText[region] == undefined ? "" : CodeToText[region];
                    });
                    this.form.address = address;
                }
            }
        }

        deleteData(index: number, mode: string, delMode: string) {
            if (mode === 'verification') {
                if (delMode === 'SINGLE') {
                    this.form2.verificationItems.splice(index, 1);
                }
                this.getItemFilter('verification');
            } else if (mode === 'test') {
                if (delMode === 'SINGLE') {
                    this.form3.testItems.splice(index, 1);
                }
                this.getItemFilter('test');
            } else if (mode === 'items') {
                if (delMode === 'SINGLE') {
                    this.form4.goodsItems.splice(index, 1);
                } else {
                    this.form4.goodsItems = this.form4.goodsItems.filter((t: any) => index !== t.number);
                }
            }
        }

        isShowAddBtn(index: number) {
            if (index === 0) {
                return true;
            } else {
                return false;
            }
        }

        getItemFilter(mode: string){
            if (mode === 'verification') {
                const itemFilterIds: any = this.form2.verificationItems.map((item: any) => {
                    return item.measuringItemId;
                });
                this.form2.measuringItemsFilter = this.form2.measuringItems.filter((m: any) => {
                    return itemFilterIds.indexOf(m.id) === -1;
                });
            }else{
                const itemFilterIds: any = this.form3.testItems.map((item: any) => {
                    return item.measuringItemId;
                });
                this.form3.measuringItemsFilter = this.form3.measuringItems.filter((m: any) => {
                    return itemFilterIds.indexOf(m.id) === -1;
                });
            }
        }

        addData(type: number, mode: string, number: number, name: string) {
            let firstChild = false;
            if (mode === 'verification') {
                const verificationItems: any = this.form2.verificationItems;
                // if (number === 0) {
                //     const numbers = verificationItems.map((test: any) => {
                //         return test.number;
                //     });
                //     number = numbers[numbers.length - 1] + 1;
                //     firstChild = true;
                // }
                const data = this.itemAppend(0, type, true, name);
                verificationItems.push(data);
                // verificationItems.sort((a: any, b: any) => a.number - b.number);
                this.form2.verificationItems = verificationItems;
            } else if (mode === 'test') {
                const testItems: any = this.form3.testItems;
                // if (number === 0) {
                //     const numbers = testItems.map((test: any) => {
                //         return test.number;
                //     });
                //     number = numbers[numbers.length - 1] + 1;
                //     firstChild = true;
                // }
                const data = this.itemAppend(0, type, true, name);
                testItems.push(data);
                // testItems.sort((a: any, b: any) => a.number - b.number);
                this.form3.testItems = testItems;
            } else if (mode === 'items') {
                const goodsItems: any = this.form4.goodsItems;
                if (number === 0) {
                    const numbers = goodsItems.map((item: any) => {
                        return item.number;
                    });
                    number = numbers[numbers.length - 1] + 1;
                    firstChild = true;
                }
                const data = this.itemV2Append(firstChild, number);
                goodsItems.push(data);
                goodsItems.sort((a: any, b: any) => a.number - b.number);
                this.form4.goodsItems = goodsItems;
            }
        }
        ruleAppend(){
            return {ruleId: '', ruleName: '', ruleNumber: ''};
        }
        itemV2Append(firstChild: any, number: number) {
            return {
                number: number,
                projectId: '', //项目ID
                firstChild: firstChild,
                measuringItemId: '',
                name: "",
                measuringItemRulesList: [this.ruleAppend()],
                type: 3,
                surveyRanges: [] as never,
                paramList: [] as any,
            };
        }

        itemAppend(number: number, type: number, firstChild: boolean, name: string) {
            return {
                number: number,
                firstChild: firstChild,
                measuringItemId: '',
                name: name,
                type: type,
                surveyRanges: [],
                measuringItemRulesList: [this.ruleAppend()],
            };
        }
        //获取详情
        getDetail() {
            authorizeCertApi.getOrganizationCertDetail({authorizeCertId: this.id, pageType: this.pageType}).then(r => {
                if (r.data.result === 0) {
                    const data = r.data.data;
                    this.form = Object.assign(this.form, data.authorizeCert);
                    this.form.status = data.authorizeCert.status.value;
                    try {
                        this.form.authorizedAreaArr = JSON.parse(this.form.authorizedArea);
                        this.changeAddress(this.form.authorizedAreaArr);
                    } catch (e) {
                        this.form.authorizedAreaArr = "";
                    }
                    //查未选择的项目列表
                    this.listMeasuringStandardItems(data.authorizeCert.ownerId);

                    //授权检定项目
                    const verificationItems = data.measuringItemDtoList == null ? [] : data.measuringItemDtoList;
                    //授权校准项目
                    const testItems = data.list == null ? [] : data.list;
                    const items = (data.goodsItems == undefined || data.goodsItems == null) ? [] : data.goodsItems;
                    //商品量授权校准/检测项目或参数名称
                    const goodsItems: any = [];
                    verificationItems.forEach((authorizeItem: any) => {
                        let paramList = [];
                        try{
                            paramList = JSON.parse(authorizeItem.surveyRangesJson);
                        }catch(e){
                            console.log(e);
                        }
                        authorizeItem.paramList = paramList;
                        authorizeItem.firstChild = true;
                        authorizeItem.measuringItemId = authorizeItem.id;
                        authorizeItem.type = 0;
                    });
                    testItems.forEach((authorizeItem: any) => {
                        let paramList = [];
                        try{
                            paramList = JSON.parse(authorizeItem.surveyRangesJson);
                        }catch(e){
                            console.log(e);
                        }
                        authorizeItem.paramList = paramList;
                        authorizeItem.firstChild = true;
                        authorizeItem.measuringItemId = authorizeItem.id;
                        authorizeItem.type = 1;
                    });

                    let num = 0;
                    items.forEach((item: any) => {
                        num++;
                        let paramList = [];
                        try{
                            paramList = JSON.parse(item.surveyRangesJson);
                        }catch(e){
                            console.log(e);
                        }
                        goodsItems.push({
                            id: item.id,
                            measuringItemId: item.measuringItemId,
                            projectId: item.projectId,
                            number: num,
                            firstChild: true,
                            name: item.name,
                            measuringItemRulesList: item.measuringItemRulesList,
                            paramList: paramList,
                        });
                    });
                    if (verificationItems.length == 0) {
                        this.form2.isNone = true;
                        verificationItems.push(this.itemAppend(1, 0, true, ""));
                    }
                    if (testItems.length == 0) {
                        this.form3.isNone = true;
                        testItems.push(this.itemAppend(1, 1, true, ""));
                    }
                    if (goodsItems.length == 0) {
                        this.form4.isNone = true;
                        goodsItems.push(this.itemV2Append(true, 1));
                    }
                    if(this.pageType === '0'){
                      this.form.name = this.userData.organizationName;
                    }
                    this.form2.verificationItems = verificationItems;
                    this.form3.testItems = testItems;
                    this.form4.goodsItems = goodsItems;
                    if (this.form.enclosure) {
                        this.fileList = [];
                        try {
                            var obj = JSON.parse(this.form.enclosure);
                            if (typeof obj == 'object' && obj) {
                                for (let i = 0; i < obj.length; i++) {
                                    this.fileList.push({name: obj[i].name, url: imageUrl + obj[i].url})
                                }
                                this.uploadConfig();
                            }
                        } catch (e) {
                            const arr = this.form.enclosure.split(",");
                            for (let i = 0; i < arr.length; i++) {
                                this.fileList.push({name: "证书文件", url: imageUrl + arr[i]})
                            }
                            this.uploadConfig();
                        }
                    }
                    this.loading = false;
                }
            })
        }

        saveOrUpdate(submitType: number, callback: any) {
            this.form.enclosure = "";
            this.form.authorizedArea = "";
            const enclosureList = this.fileList.map((e: any) => {
                return {
                    name: e.name,
                    url: e.url.replace(imageUrl, "")
                }
            });
            this.form.enclosure = enclosureList.length == 0 ? "" : JSON.stringify(enclosureList);
            if (this.form.authorizedAreaArr.length > 0) {
                this.form.authorizedArea = JSON.stringify(this.form.authorizedAreaArr);
            }
            if (this.limit == 1) {
                //证明文件是pdf
                this.form.pdfPath = this.form.enclosure;
            }
            //校验表单
            this.formVerification(submitType, () => {
                const loading = this.$loading({
                    text: '正在保存',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const result = this.packageResult();
                if (this.form.status == 2 && this.sysAuthorizeCertUpdate && this.mode === 1) {
                    submitType = 2;
                }
                result.submitType = submitType;
                authorizeCertApi.saveOrUpdate(result).then((res: any) => {
                    loading.close();
                    if (res.data.result !== 0) {
                        this.$message.error(res.data.message);
                        //报错信息
                        return;
                    }
                    let $tempSave = this.$refs.tempSave as HTMLFormElement;
                    if ($tempSave) {
                        $tempSave.deleteUserConfig();
                    }

                    if (callback) {
                        callback();
                    } else {
                        this.$message.success("保存成功，1秒后返回上一页！");
                        setTimeout(() => {
                            this.closePage()
                        }, 1000);
                    }
                });
            });
        }

        //校验表单
        formVerification(submitType: number, callback: any) {
            //不通过  不做校验
            if (submitType == 3) {
                callback();
                return;
            }
            let form = this.$refs.form as HTMLFormElement;
            let form2 = this.$refs.form2 as HTMLFormElement;
            let form3 = this.$refs.form3 as HTMLFormElement;
            let form4 = this.$refs.form4 as HTMLFormElement;
            // const isVerify4 = this.form4.goodsItems.filter((item: any) => item.projectId != "").length > 0;
            form.validate((valid: any) => {
                if (valid) {
                    form2.validate((valid: any) => {
                        if (valid) {
                            form3.validate((valid: any) => {
                                if (valid) {
                                    // if(isVerify4){
                                    form4.validate((valid: any) => {
                                        if (valid) {
                                            callback();
                                        } else {
                                            this.$message.warning("未填写完整信息");
                                        }
                                    });
                                    // }else{
                                    //     callback();
                                    // }
                                } else {
                                    this.$message.warning("未填写完整信息");
                                }
                            });
                        } else {
                            this.$message.warning("未填写完整信息");
                        }
                    });
                } else {
                    this.$message.warning("未填写完整信息");
                }
            });
        }

        packageResult() {
            const verificationItems = this.cloneObjectFn(this.form2.verificationItems.filter((item: any) => item.firstChild));
            const testItems = this.cloneObjectFn(this.form3.testItems.filter((item: any) => item.firstChild));
            const goodsItems = this.cloneObjectFn(this.form4.goodsItems);
            let measurings = [] as any;
            //整理授权检定项目 table1
            if (!this.form2.isNone) {
                verificationItems.forEach((v: any) => {
                    measurings.push({
                        measuringItemId: v.measuringItemId,
                        type: 0
                    });
                });
            }
            //整理授权校准检测项目 table2
            if (!this.form3.isNone) {
                testItems.forEach((v: any) => {
                    measurings.push({
                        measuringItemId: v.measuringItemId,
                        type: 1
                    });
                });
            }
            //整理 商品量授权校准/检测项目 table3
            let items = [] as any;
            if (!this.form4.isNone) {
                items = goodsItems;
                items = this.packageItemsSurveyRanges(items);
            }
            const form = this.form as any;
            form.authorizedAreaText = this.regionCodeToText(form.authorizedAreaArr);
            const data = {authorizeCert: form, authorizeItems: measurings, goodsItems: items} as any;
            if(this.pageType === '0'){
                data.authorizeCert.id = null;
                data.authorizeCert.agingStatus = 1;
                data.authorizeCert.manageStatus = this.manageStatus;
                if([1,2, 4, 5].indexOf(this.manageStatus) > -1){
                  data.authorizeCert.replaceId = this.id;
                }
            }
            return data
        }

        //整理授权项目测量范围
        packageItemsSurveyRanges(measuringItems: any) {
            //整理 授权项目
            const items = measuringItems.filter((item: any) => item.firstChild);
            items.forEach((item: any) => {
                item.paramList.forEach((param: Param) => {
                    param.paramType = 2;
                });
            });
            return items;
        }

        update() {
            return;
        }

        handleAvatarSuccess(res: any, file: any) {
            if (res.result === 0) {
                const rData = res.data;
                // this.fileList.push({name: file.name,url: imageUrl+rData})
                this.fileList.push({name: "计量授权证书.pdf", url: imageUrl + rData})
                this.uploadConfig();
            }
        }

        //控制上传组件参数
        uploadConfig() {
            if (this.fileList.length == 0) {
                this.accept = ".png,.jpg,.pdf";
                this.limit = 10;
                this.listType = "picture-card"
            } else {
                const fix = this.filesuffix(this.fileList[0].url);
                if (fix == "jpg" || fix == "png") {
                    this.accept = '.png,.jpg';
                } else {
                    this.accept = '.pdf';
                    this.limit = 1;
                    this.listType = "text";
                }
            }
        }

        handleRemove(file: any, fileList: any) {
            const index = this.fileList.findIndex((e: any) => e.url === file.url);
            if (index > -1) {
                this.fileList.splice(index, 1);
            }
            this.fileList.map((e: any, index: number) => {
                e.name = "证书影印件" + (index + 1);
            })
            this.uploadConfig();
        }

        handlePictureCardPreview(file: any) {
            const fix = this.filesuffix(file.url);
            if (fix == "pdf") {
                window.open(baseUrl + "/file/download?file=" + file.url.replace(imageUrl, "") + "&name=" + file.name, '_blank');
            } else {
                this.dialogImageUrl = file.url;
                this.imagePreviewVisible = true;
            }
        }

        //上传监控
        beforeAvatarUpload(file: any) {
            const isJPG = file.type === 'image/jpeg';
            const isPNG = file.type === 'image/png';
            const isPDF = file.type === 'application/pdf';

            if (!isJPG && !isPNG && !isPDF) {
                this.$message.error('上传图片只能是 JPG / PNG / PDF格式!');
            }
            return (isJPG || isPNG || isPDF);
        }

        filesuffix(fileName: string) {
            const first = fileName.lastIndexOf(".");//取到文件名开始到最后一个点的长度
            const namelength = fileName.length;//取到文件名长度
            const filesuffix = fileName.substring(first + 1, namelength);//截取获得后缀名
            return filesuffix;
        }

        submitAddSurveyRanges(e: any) {
            const params = e.params;
            const {index} = params;
            let paramList = this.cloneObjectFn(e.paramList);
            let item = this.form4.goodsItems[index] as any;
            item.paramList = paramList;
            this.closeAddSurveyRangesDiglog();
        }

        openAddSurveyRangesDiglog(surveyRanges: any, type: string, index: number) {
            surveyRanges = this.cloneObjectFn(surveyRanges);
            this.addSurveyRanges.surveyRanges = surveyRanges;
            this.addSurveyRanges.params = {type: type, index: index};
            this.addSurveyRanges.visible = true;
        }

        closeAddSurveyRangesDiglog() {
            this.addSurveyRanges.visible = false;
            this.addSurveyRanges.surveyRanges = [];
            this.addSurveyRanges.params = null;
        }

        cloneObjectFn(obj: any) {
            return JSON.parse(JSON.stringify(obj));
        }

        clearForm() {
            const options = this.$options as any;
            Object.assign(this.$data, options.data.call(this));
            this.init();
        }
        //获取项目
        listMeasuringStandardItems(organizationId: string) {
            //授权检定项目
            measuringStandardApi.listMeasuringStandardItems({organizationId: organizationId, pageType: this.pageType, filterType: 0, appendAuthorizeCertId: this.id, ruleNumber: 'JJG'}).then((r: any) => {
                if (r.data.result === 0) {
                    const {filterItems, allItems} = r.data.data;
                    this.form2.measuringItemsFilter = filterItems;
                    this.form2.measuringItems = allItems;
                }
            });

            //授权校准项目
            measuringStandardApi.listMeasuringStandardItems({organizationId: organizationId, pageType: this.pageType, filterType: 1, appendAuthorizeCertId: this.id, ruleNumber: ''}).then((r: any) => {
                if (r.data.result === 0) {
                    const {filterItems, allItems} = r.data.data;
                    this.form3.measuringItemsFilter = filterItems;
                    this.form3.measuringItems = allItems;
                }
            });
            this.loading = false;
        }
        getTempData(e: any) {
            if (!e){
                this.init();
                return;
            }
            const rData = JSON.parse(e);
            this.form = rData.form;
            this.form2 = rData.form2;
            this.form3 = rData.form3;
            this.form4 = rData.form4;
            if (rData.fileList) {
                this.fileList = rData.fileList;
                const enclosureList = this.fileList.map((e: any) => {
                    return {
                        name: e.name,
                        url: e.url.replace(imageUrl, "")
                    }
                });
                this.form.enclosure = JSON.stringify(enclosureList);
            }
            this.loading = false;
        }
    }
